module.exports = __webpack_public_path__ + "static/img/icons.336e940.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Pods/icons.png
// module id = 8g5h
// module chunks = 0